
    <fieldmagic-primary-button
      purpose="icon"
      [icon]="[{
        icon: 'envelope-open-text',
        size: 'list-icon'
      }]"
      tooltip="Send welcome email"
      klass="p-0"
      [isInProgress]="processing$ | async"
      (click)="onClick()"
    ></fieldmagic-primary-button>
  